import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { page } from "../lib/analytics";

/**
 * Fires an analytics page event on every route change.
 * Mount once inside the <BrowserRouter>.
 */
export default function AnalyticsPageTracker() {
  const location = useLocation();
  useEffect(() => {
    page(location.pathname + location.search);
  }, [location.pathname, location.search]);
  return null;
}
